import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/daily-attendances',
    name: 'daily-attendance',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/daily-attendance/index.vue')
  }
]
